import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Tooltip, useMediaQuery } from "@mui/material";


const reviews = [
  {
    name: "Rafia Islam",
    initials: "RI",
    text: "I had the opportunity to speak with Huda while exploring a plan for an Al Mamsha 1-bedroom apartment. The conversation was very insightful. She demonstrated strong market knowledge and explained everything clearly, honestly, and professionally. I truly appreciated her patience and no-pressure approach. I will definitely reach out to her again once my mortgage is finalized.",
  },
  {
    name: "Shilpa Jayaram",
    initials: "SJ",
    text: "My experience with Anne Baloch was truly amazing while searching for a property. She has excellent knowledge of the real estate market and was extremely helpful and patient in understanding my needs. Her professionalism made the entire process smooth and stress-free.",
  },
  {
    name: "Sana Khan",
    initials: "SK",
    text: "Anas did an excellent job helping me secure a wonderful unit in Aljada. He carefully listened to my preferences, provided valuable insights about the community, and ensured everything went smoothly from viewings to finalizing the deal. Highly recommended.",
  },
  {
    name: "Rayyan Sallie",
    initials: "RS",
    text: "I recently purchased a property through Mohammed Anas at Vision X Nexus and had an excellent experience. He was professional, knowledgeable, and went above and beyond to ensure everything was handled properly. I highly recommend his services.",
  },
  {
    name: "Vimarsha Kavinda",
    initials: "VK",
    text: "Anne Baloch is an exceptional sales professional who consistently demonstrates strong product knowledge and a customer-focused approach. She is responsive, attentive, and takes the time to explain options clearly. Highly recommended for anyone seeking a reliable advisor.",
  },
  {
    name: "Ghazool Ali",
    initials: "GA",
    text: "My experience with Zain, Sales Manager, was absolutely outstanding. He is professional, honest, and treats every client like a friend. Zain never pressures you into making decisions and provides clear guidance throughout the process. Communication was always fast and organized.",
  },
  {
    name: "Ahmed Marwan",
    initials: "AM",
    text: "I recently spoke with Mr. Omer about opportunities in the Hay Al Barashi area and was very impressed. He was professional, clear, and helpful, explaining everything simply and sharing tailored payment options. I will definitely reach out again.",
  },
  {
    name: "Moiz Zakir",
    initials: "MZ",
    text: "Zein from Vision X Nexus has been extremely helpful and knowledgeable. He guided me throughout the process and provided options that suited my requirements and budget, especially for the Masaar project. He personally handles negotiations and provides excellent support.",
  },
];

export default function ClientReviewsSlider() {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box
      sx={{
        // backgroundColor: "#212121",
        backgroundColor: "var(--color-bg)",

        py: { xs: 3, md: 6 },
        overflow: "hidden", // ✅ CRITICAL
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* HEADER */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 4 } }}>
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.35em",
              fontSize: 11,
              mb: 2,
            }}
          >
            CLIENT REVIEWS
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "2rem", md: "2.8rem" },
              fontWeight: 500,
              mb: 0,
            }}
          >
            <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
              Trusted by
            </Box>{" "}
            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Our Clients
            </Box>
          </Typography>

          <Typography
            sx={{
              // color: "rgba(255,255,255,0.65)",
              color: "var(--color-text-muted)",

              maxWidth: 560,
              mx: "auto",
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            Discreet, professional, and results-driven real estate experiences.
          </Typography>
        </Box>

        {/* SLIDER */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{
            delay: 4200,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          loop
          spaceBetween={30}
          centeredSlides
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2, centeredSlides: true },
            1200: { slidesPerView: 3, centeredSlides: true },
          }}
          style={{
            paddingBottom: "40px",
            paddingTop: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "12px",
          }} // ✅ space for dots
        >
          {reviews.map((review, i) => (
            <SwiperSlide key={i}>
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {/* <Box
                  sx={{
                    height: "100%",
                    borderRadius: "32px",
                    p: { xs: 4, md: 5 },
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.015))",
                    border: "1px solid rgba(255,255,255,0.08)",
                    boxShadow: "0 40px 120px rgba(0,0,0,0.8)",
                    transition: "all 0.4s ease",
                    position: "relative",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      borderColor: "rgba(201,162,77,0.45)",
                    },
                  }}
                > */}

                <Box
                  sx={{
                    height: "100%",
                    borderRadius: "32px",
                    p: { xs: 4, md: 4 },
                    background: "var(--color-white)",
                    border: "1px solid rgba(0,0,0,0.08)",
                    // boxShadow: "0 30px 70px rgba(0,0,0,0.18)",
                    transition: "all 0.4s ease",
                    position: "relative",

                    "&:hover": {
                      transform: "translateY(-6px)",
                      borderColor: "var(--color-gold)",
                      boxShadow: "0 40px 90px rgba(0,0,0,0.22)",
                    },
                  }}
                >
                  {/* QUOTE */}
                  <Typography
                    sx={{
                      position: "absolute",
                      top: 18,
                      right: 22,
                      fontSize: 64,
                      // color: "rgba(201,162,77,0.18)",
                      color: "rgba(207,172,106,0.25)",

                      fontFamily: "serif",
                    }}
                  >
                    “
                  </Typography>

                  {isMobile ? (
                    /* 📱 MOBILE → SHOW FULL TEXT */
                    <Typography
                      sx={{
                        color: "var(--color-text-muted)",
                        fontSize: 14.5,
                        lineHeight: 1.9,
                      }}
                    >
                      {review.text}
                    </Typography>
                  ) : (
                    /* 🖥 DESKTOP → TRUNCATED + TOOLTIP */
                    <Tooltip
                      title={
                        <Typography
                          sx={{
                            fontSize: 14,
                            lineHeight: 1.8,
                            color: "#fff",
                            maxWidth: 340,
                          }}
                        >
                          {review.text}
                        </Typography>
                      }
                      arrow
                      placement="top"
                      enterDelay={300}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#1c1c1c",
                            border: "1px solid var(--color-gold)",
                            boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                            p: 2,
                            borderRadius: 2,
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#1c1c1c",
                          },
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          color: "var(--color-text-muted)",
                          fontSize: 14.5,
                          lineHeight: 1.9,

                          /* Same height for all cards */
                          display: "-webkit-box",
                          WebkitLineClamp: 4,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          cursor: "help",
                        }}
                      >
                        {review.text}
                      </Typography>
                    </Tooltip>
                  )}

                  {/* AUTHOR */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      marginTop: "20px",
                    }}
                  >
                    {/* <Box
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: "50%",
                        background:
                          "linear-gradient(180deg, rgba(33,33,33,1), rgba(33,33,33,0.9))",
                        border: "1px solid var(--color-gold)",
                        color: "var(--color-gold)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 500,
                        letterSpacing: "0.1em",
                      }}
                    > */}
                    <Box
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: "50%",
                        background: "var(--color-bg)",
                        border: "1px solid var(--color-gold)",
                        color: "var(--color-gold)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        letterSpacing: "0.1em",
                      }}
                    >
                      {review.initials}
                    </Box>

                    <Typography
                      sx={{
                        // color: "var(--color-white)",
                        color: "var(--color-text-primary)",

                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      {review.name}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
      <style>
        {`
 .swiper-pagination {
  bottom: 10px !important;
}

.swiper-pagination-bullet {
  background: rgba(207, 172, 106, 0.35);
  width: 8px;
  height: 8px;
  opacity: 1;
  transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
  background: var(--color-gold);
  width: 18px;
  border-radius: 10px;
}

`}
      </style>

      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
